import React from 'react';
import { Box, Card, Container, Grid, Stack, Typography } from '@mui/material';
import SecurityIcon from '@mui/icons-material/Security';
import ForumIcon from '@mui/icons-material/Forum';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { PublicLandingFooter, PublicLandingNav } from './LandingShared';

const primaryColor = '#0A7F74';
const deepColor = '#04534B';

const FeaturesPage: React.FC = () => {
  return (
    <Box sx={{ bgcolor: '#fff', px: '1px' }}>
      <PublicLandingNav active="features" />

      <Container maxWidth="lg" sx={{ py: { xs: 4, md: 7 }, px: '1px !important' }}>
        <Box sx={{ textAlign: 'center', mb: 5 }}>
          <Typography variant="h3" sx={{ fontWeight: 800, color: deepColor, mb: 1 }}>
            Features Built for Real Communities
          </Typography>
          <Typography sx={{ color: '#6b7280', maxWidth: 760, mx: 'auto' }}>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante
            venenatis dapibus posuere velit aliquet. Aenean eu leo quam. Pellentesque ornare sem
            lacinia quam venenatis vestibulum.
          </Typography>
        </Box>

        <Grid container spacing={2}>
          {[
            {
              title: 'Secure & Private',
              icon: <SecurityIcon />,
              desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec sed odio dui. Donec id elit non mi porta gravida.'
            },
            {
              title: 'Built for Communities',
              icon: <ForumIcon />,
              desc: 'Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Nullam quis risus eget urna mollis ornare vel eu leo.'
            },
            {
              title: 'Save & Grow Together',
              icon: <TrendingUpIcon />,
              desc: 'Cras mattis consectetur purus sit amet fermentum. Vestibulum id ligula porta felis euismod semper.'
            }
          ].map((item) => (
            <Grid item xs={12} md={4} key={item.title}>
              <Card elevation={0} sx={{ p: 3, border: '1px solid #e5e7eb', borderRadius: 3, height: '100%' }}>
                <Box sx={{ display: 'inline-flex', p: 1.4, borderRadius: '50%', bgcolor: '#e6f4f2', color: primaryColor, mb: 1.5 }}>
                  {item.icon}
                </Box>
                <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
                  {item.title}
                </Typography>
                <Typography sx={{ color: '#6b7280', fontSize: '0.95rem' }}>{item.desc}</Typography>
              </Card>
            </Grid>
          ))}
        </Grid>

        <Grid container spacing={3} alignItems="center" sx={{ mt: 2 }}>
          <Grid item xs={12} md={6}>
            <Typography variant="h4" sx={{ fontWeight: 800, color: deepColor, mb: 2 }}>
              Why teams choose UTrust
            </Typography>
            <Stack spacing={1.2}>
              {[
                'Lorem ipsum dolor sit amet consectetur.',
                'Vestibulum id ligula porta felis euismod semper.',
                'Nullam quis risus eget urna mollis ornare vel eu leo.',
                'Donec ullamcorper nulla non metus auctor fringilla.'
              ].map((line) => (
                <Stack key={line} direction="row" spacing={1.25} alignItems="center">
                  <CheckCircleIcon sx={{ color: primaryColor, fontSize: 20 }} />
                  <Typography sx={{ color: '#374151' }}>{line}</Typography>
                </Stack>
              ))}
            </Stack>
          </Grid>
          <Grid item xs={12} md={6}>
            <Card elevation={0} sx={{ p: 3, borderRadius: 4, border: '1px solid #e5e7eb', bgcolor: '#f8fbfa' }}>
              <Typography sx={{ color: '#111827', fontWeight: 700, mb: 1 }}>Platform Highlights</Typography>
              <Typography sx={{ color: '#6b7280' }}>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus sagittis lacus vel
                augue laoreet rutrum faucibus dolor auctor. Integer posuere erat a ante venenatis.
              </Typography>
            </Card>
          </Grid>
        </Grid>
      </Container>

      <PublicLandingFooter />
    </Box>
  );
};

export default FeaturesPage;
